import { useLocation, useNavigate } from "react-router-dom";
import navBarData from "../../Routes/navBarData";

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const role = Number(authUser?.role);
  const isRetailer = role === 5;
  const position = authUser?.position;

  let tabs = navBarData.filter(
    (item) =>
      Array.isArray(item.roles) &&
      item.roles.includes(role) &&
      item.path &&
      item.icon
  );

  if (role === 3) {
    const typeOfUser = authUser?.type_of_user;
    if (typeOfUser === "Operation") {
      tabs = tabs.filter((item) => item.id !== "empdash");
    } else {
      tabs = tabs.filter((item) => item.id !== "oprdash");
    }
  }

  if (role === 3 && position === "EXECUTIVE" ) {
      const hiddenTabs = ["teammember"];
    tabs = tabs.filter((item) => !hiddenTabs.includes(item.id));
      
  } 

  if (role === 5) {
    const hiddenTabs = ["retwarnty", "customerlist", "retinv"];
    tabs = tabs.filter((item) => !hiddenTabs.includes(item.id));
  }

  return (
    <div
      className={`
        fixed bottom-3 left-3 right-3 z-50
        px-2 py-2 rounded-full shadow-xl
        ${
          isRetailer
            ? "backdrop-blur-2xl bg-white/40 border border-white/30"
            : "backdrop-blur-xl bg-white/70 border border-white/40"
        }
      `}
    >
      <div
        className={`
          flex items-center
          ${
            isRetailer
              ? tabs.length <= 4
                ? "justify-between"
                : "gap-1 overflow-x-auto scrollbar-hide"
              : "gap-1 overflow-x-auto whitespace-nowrap scroll-smooth scrollbar-hide"
          }
        `}
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;

          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`
                flex flex-col items-center justify-center
                min-w-[64px] px-3 py-2
                rounded-3xl text-[10px]
                transition-all duration-200
                flex-shrink-0
                ${tabs.length <= 4 ? "flex-1" : ""}
                ${
                  isActive
                    ? "bg-blue-600 text-white shadow-md"
                    : "text-slate-700 hover:bg-white/60"
                }
              `}
            >
              <Icon className="w-6 h-6" />
              <span className="mt-0.5 leading-none text-sm">
                {tab.label.split(" ")[0]}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}


// import { useLocation, useNavigate } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";

// export default function MobileBottomNav() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const role = Number(authUser?.role);

//   // Filter tabs for current role
//   const tabs = navBarData.filter(
//     (item) =>
//       Array.isArray(item.roles) &&
//       item.roles.includes(role) &&
//       item.path &&
//       item.icon
//   );

//   if (tabs.length === 0) {
//     console.warn("⚠️ No bottom nav items found for role:", role);
//   }

//   return (
//     <div
//       className="
//         fixed bottom-3 left-3 right-3 z-50
//         backdrop-blur-xl bg-white/70
//         border border-white/40
//         rounded-full shadow-xl
//         px-2 py-2
//       "
//     >
//       {/* 👇 Scroll container */}
//       <div
//         className="
//           flex items-center gap-1
//           overflow-x-auto overflow-y-hidden
//           whitespace-nowrap
//           scroll-smooth
//           scrollbar-hide
//         "
//       >
//         {tabs.map((tab) => {
//           const Icon = tab.icon;
//           const isActive = location.pathname === tab.path;

//           return (
//             <button
//               key={tab.id}
//               onClick={() => navigate(tab.path)}
//               className={`
//                 flex flex-col items-center justify-center
//                 min-w-[64px] px-3 py-2
//                 rounded-xl text-[10px]
//                 transition-all duration-200
//                 flex-shrink-0
//                 ${
//                   isActive
//                     ? "bg-blue-600 text-white shadow-md"
//                     : "text-slate-700 hover:bg-white/60"
//                 }
//               `}
//             >
//               <Icon className="w-5 h-5" />
//               <span className="mt-0.5 leading-none">
//                 {tab.label.split(" ")[0]}
//               </span>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// }



// import { useLocation, useNavigate } from "react-router-dom";
// import navBarData from "../../Routes/navBarData";

// export default function MobileBottomNav() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const role = Number(authUser?.role);

//   // 🔍 ANALYZE navBarData for current role (5 / 6)
//   const tabs = navBarData
//     .filter(
//       (item) =>
//         Array.isArray(item.roles) &&
//         item.roles.includes(role) &&
//         item.path &&               // must have route
//         item.icon                  // must have icon
//     )
//     // 🔽 OPTIONAL: limit number of bottom nav items;

//   // Safety log (remove later)
//   if (tabs.length === 0) {
//     console.warn("⚠️ No bottom nav items found for role:", role);
//   }

//   return (
//     <div
//       className="
//         fixed bottom-3 left-3 right-3 z-50
//         backdrop-blur-xl bg-white/70
//         border border-white/40
//         rounded-full shadow-xl
//         px-2 py-2
//         flex justify-between
//       "
//     >
//       {tabs.map((tab) => {
//         const Icon = tab.icon;
//         const isActive = location.pathname === tab.path;

//         return (
//           <button
//             key={tab.id}
//             onClick={() => navigate(tab.path)}
//             className={`
//               flex flex-col items-center justify-center
//               px-3 py-2 rounded-xl text-[10px]
//               transition-all duration-200
//               ${
//                 isActive
//                   ? "bg-blue-600 text-white shadow-md"
//                   : "text-slate-700 hover:bg-white/60"
//               }
//             `}
//           >
//             <Icon className="w-5 h-5" />
//             <span className="mt-0.5 leading-none">
//               {tab.label.split(" ")[0]}
//             </span>
//           </button>
//         );
//       })}
//     </div>
//   );
// }



// import { useLocation, useNavigate } from "react-router-dom";
// import navBarData from "../../Routes/navBarData"; // ✅ adjust path if needed

// export default function MobileBottomNav() {
// const navigate = useNavigate();
// const location = useLocation();

// const authUser = JSON.parse(localStorage.getItem("authUserData"));
// const role = Number(authUser?.role);

// // 👇 Only these items should appear in bottom nav
// const bottomNavIds = [
//     "custdashboard",
//     "custwarnty",
//     "custclaims",
//     "custdoc",
//     "custspt",
// ];

// // 👇 Filter from navBarData
// const tabs = navBarData.filter(
//     (item) =>
//     bottomNavIds.includes(item.id) &&
//     (!item.roles || item.roles.includes(role))
// );

// return (
//     <div
//     className="
//         fixed bottom-3 left-3 right-3 z-50
//         backdrop-blur-xl bg-white/70
//         border border-white/40
//         rounded-2xl shadow-xl
//         px-2 py-2
//         flex justify-between
//     "
//     >
//     {tabs.map((tab) => {
//         const Icon = tab.icon;
//         const isActive = location.pathname === tab.path;

//         return (
//         <button
//             key={tab.id}
//             onClick={() => navigate(tab.path)}
//             className={`
//             flex flex-col items-center justify-center
//             px-3 py-2 rounded-xl text-[10px]
//             transition-all duration-200
//             ${
//                 isActive
//                 ? "bg-blue-600 text-white shadow-md"
//                 : "text-slate-700 hover:bg-white/60"
//             }
//             `}
//         >
//             <Icon className="w-5 h-5" />
//             {/* Optional label (can hide if you want icon-only) */}
//             <span className="mt-0.5 leading-none">
//             {tab.label.split(" ")[0]}
//             </span>
//         </button>
//         );
//     })}
//     </div>
// );
// }
